export interface ILayoutState {
	sidebarPresentAsOverlay: boolean;
	sidebarPresentAsOverlayVisible: boolean;
	isLoading: boolean;
}

export const initialLayoutState: ILayoutState = {
	sidebarPresentAsOverlay: false,
	sidebarPresentAsOverlayVisible: false,
	isLoading: false,
};
